import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/home';

export default function FeaturedSection() {
  return (
    <section id="featured" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-2">热门推荐</h2>
            <p className="text-sm text-foreground-500">妈妈们都在看的哺乳育儿漫画</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {article.isHot && (
                  <span className="absolute top-3 left-3 px-2 py-1 bg-primary-500 text-white text-xs font-medium rounded-md whitespace-nowrap">
                    热门
                  </span>
                )}
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.readTime}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading text-foreground-800 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-4 flex-wrap">
                  {article.tags.map((tag) => (
                    <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">
                      #{tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}